import { cn } from '@/utils';

/**
 * TextSplitMap Component
 *
 * This component takes a string of text, splits it by newline characters, and renders
 * each line as a separate div. If a line starts with a hyphen, it is treated as a list
 * item and rendered with a bullet point.
 */
export const TextSplitMap: React.FC<{
  /** Additional class names to apply to each line of text. */
  className?: string;
  /** The HTML tag to use for each line of text. Defaults to 'div'. */
  tag?: keyof JSX.IntrinsicElements;
  /** The text to be split and rendered. */
  text?: string;
}> = ({ className, tag = 'div', text }) => {
  const classNames = cn('mb-2 flex gap-2', className);

  // If text is undefined or empty, return null to avoid rendering an empty component
  if (!text) return null;

  // Split the text by newline characters and map each line to a div.
  // If a line starts with a hyphen, render it as a list item with a bullet point.
  return text.split('\n').map((line, index) => {
    const Tag = tag;
    return (
      <Tag key={index} className={classNames}>
        {line.startsWith('\-') ? (
          <span role="listitem" className="ml-2 flex items-start gap-3">
            <span>•</span>
            <span>{line.slice(2)}</span>
          </span>
        ) : (
          <span>{line}</span>
        )}
      </Tag>
    );
  });
};

TextSplitMap.displayName = 'TextSplitMap';

export default TextSplitMap;
